export class DateService {
  static getDayKey(date = new Date()) {
    return date.toISOString().split('T')[0];
  }

  static isToday(dateString) {
    return this.getDayKey() === dateString;
  }

  static isYesterday(dateString) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return this.getDayKey(yesterday) === dateString;
  }

  static formatDate(date) {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  }

  static formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  }

  static formatNumber(num, decimals = 0) {
    if (num < 1000) {
      return num.toFixed(decimals);
    }
    
    const units = ['', 'K', 'M', 'B', 'T'];
    let unitIndex = 0;
    let value = num;
    
    while (value >= 1000 && unitIndex < units.length - 1) {
      value /= 1000;
      unitIndex++;
    }
    
    return value.toFixed(decimals) + units[unitIndex];
  }
}